// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2026 Vic Zhu <viczhu2014@gmail.com>

import { Box, Typography } from '@mui/material'
import {
  BooleanInput,
  Create,
  NumberInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useTranslate,
} from 'react-admin'

const FoodCreate = () => {
  const translate = useTranslate()
  const speciesChoices = [
    { id: 'dog', name: translate('resources.foods.species.dog') },
    { id: 'cat', name: translate('resources.foods.species.cat') },
    { id: 'both', name: translate('resources.foods.species.both') },
  ]
  const formChoices = [
    { id: 'dry', name: translate('resources.foods.form.dry') },
    { id: 'wet', name: translate('resources.foods.form.wet') },
    { id: 'treat', name: translate('resources.foods.form.treat') },
    { id: 'topper', name: translate('resources.foods.form.topper') },
    { id: 'raw', name: translate('resources.foods.form.raw') },
    { id: 'other', name: translate('resources.foods.form.other') },
  ]
  return (
    <Create redirect="list">
      <SimpleForm>
        <Typography variant="h6" sx={{ mb: 1 }}>
          {translate('resources.foods.sections.identity')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <TextInput source="brand" validate={required()} />
          <TextInput source="productName" validate={required()} />
          <SelectInput source="species" choices={speciesChoices} validate={required()} />
          <SelectInput
            source="form"
            choices={formChoices}
            validate={required()}
            defaultValue="dry"
          />
        </Box>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          {translate('resources.foods.sections.energy')}
        </Typography>
        <NumberInput
          source="kcalPerGram"
          validate={required()}
          step={0.01}
          min={0}
          max={10}
          helperText={translate('resources.foods.helpers.kcal_per_gram')}
        />

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          {translate('resources.foods.sections.macros')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <NumberInput source="proteinPercent" min={0} max={100} />
          <NumberInput source="fatPercent" min={0} max={100} />
          <NumberInput source="carbohydratePercent" min={0} max={100} />
          <NumberInput source="fiberPercent" min={0} max={100} />
          <NumberInput source="moisturePercent" min={0} max={100} />
        </Box>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          {translate('resources.foods.sections.diabetes')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <NumberInput source="glycemicIndex" min={0} max={100} />
          <BooleanInput source="diabeticFriendly" />
        </Box>

        <BooleanInput source="isActive" defaultValue={true} />
      </SimpleForm>
    </Create>
  )
}

export default FoodCreate
